import React, { useState } from 'react';
import { Box, Typography, Avatar, Paper, Grid, Button, Divider, Badge, IconButton, Menu, MenuItem } from '@mui/material';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Utils from '../../constants/Utils';
import GradeIcon from '@mui/icons-material/Grade';
import SmsIcon from '@mui/icons-material/Sms';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { uplodateLoading } from '../../../redux/features/common/commonSlice';
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';
import { showDangerToast, showToast } from '../../constants/toaster';

export const EventDetailComponent = props => {
    const { formatDate } = Utils();
    const userData = useSelector(state => state?.userData)
    const dispatch = useDispatch()
    const { id } = useParams()
    const [anchorEl, setAnchorEl] = useState(null); // State for menu anchor
    const open = Boolean(anchorEl);

    // Handle menu open
    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Handle menu close
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleShowTotalSubmission = () => {
        props?.onShowTotalSubmission()
    }



    return (
        <Box sx={{ padding: 4 }}>
            {/* Banner Image */}
            <Box
                sx={{
                    height: 200,
                    backgroundImage: 'url(' + props?.eventDetails?.banner + ')', // Replace with actual image URL
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    borderRadius: 1,
                    marginBottom: 2,
                }}
            >
            </Box>

            {/* Event Details */}
            <Paper sx={{ padding: 2, marginBottom: 2 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} textAlign={'left'}>
                        <Typography variant="h6">Title: {props?.eventDetails?.title}</Typography>
                        <Typography>Description: {props?.eventDetails?.description}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={3} textAlign={'left'}>
                        <Typography>Start Date: {formatDate(props?.eventDetails?.startDate)}</Typography>
                        <Typography>End Date: {formatDate(props?.eventDetails?.endDate)}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={3} textAlign={'left'}>
                        <Typography title='Click To View'>Total Joined: {props?.eventDetails?.participatedUser?.length}</Typography>
                        <Typography style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }} onClick={() => handleShowTotalSubmission()} title='Click To View'>Total Submissions: {props?.eventDetails?.eventVideos?.length}</Typography>
                    </Grid>
                </Grid>
            </Paper>

            {/* Leaderboard */}
            <Typography variant="h5" gutterBottom>Leaderboard</Typography>
            <>
                {props?.eventDetails?.selectedVideosWinnerList?.length > 0 ? props?.eventDetails?.selectedVideosWinnerList?.map((data) => {
                    return <>
                        <Paper sx={{ padding: 2, marginBottom: 2 }}>
                            <Grid container alignItems="center">
                                {/* Profile Picture */}
                                <Grid item>
                                    {/* Position Badge */}
                                    <Badge
                                        overlap="circular"
                                        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        badgeContent={
                                            <Avatar
                                                sx={{
                                                    width: 24,
                                                    height: 24,
                                                    backgroundColor: 'gold',
                                                    fontSize: '0.75rem',
                                                    color: 'black',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                {data?.position}
                                            </Avatar>
                                        }
                                    >
                                        <Avatar sx={{ mr: 1 }} src={data?.video?.userProfile || undefined}>
                                            {!data?.video?.userProfile && data?.video?.userName.charAt(0).toUpperCase()}
                                        </Avatar>                                    </Badge>
                                </Grid>

                                {/* User Info */}
                                <Grid item xs={2}>
                                    <Typography variant="body1">Username: {data?.video?.userName}</Typography>
                                    <Typography variant="body1">Full Name: {data?.video?.userName}</Typography>
                                </Grid>

                                {/* Likes and Views */}
                                <Grid item xs={2} sx={{ textAlign: 'center' }}>
                                    <GradeIcon />
                                    <Typography variant="body2">{data?.video?.totalLikes} Likes</Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: 'center' }}>
                                    <SmsIcon />
                                    <Typography variant="body2">{data?.video?.totalComments} Comments</Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: 'center' }}>
                                    <VisibilityIcon />
                                    <Typography variant="body2">{data?.video?.totalViews} Views</Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: 'center' }}>
                                    {/* Price Tag */}
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            backgroundColor: '#4caf50',
                                            color: 'white',
                                            borderRadius: 1,
                                            padding: '4px 8px',
                                            display: 'inline-block',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {data?.prize} Chips
                                    </Typography>
                                </Grid>
                                {/* <Grid item xs={1} sx={{ textAlign: 'right' }}>
                                    <IconButton onClick={handleMenuOpen}>
                                        <MoreVertIcon />
                                    </IconButton>
                                    <Menu
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleMenuClose}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                    >
                                        <MenuItem onClick={handleMenuClose}>Assign Winner</MenuItem>
                                        <MenuItem onClick={handleMenuClose}>Remove Winner</MenuItem>
                                    </Menu>
                                </Grid> */}
                            </Grid>
                        </Paper>
                    </>
                })
                    : <>
                        No Winner Set Yet.
                    </>
                }

                {/* {props?.eventDetails?.winnerCriteria && props?.eventDetails?.winnerCriteria?.map((data) => {
                    return <>
                        <Paper sx={{ padding: 2, marginBottom: 2 }}>
                            <Grid container alignItems="center">
                                <Grid item>
                                    <Badge
                                        overlap="circular"
                                        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        badgeContent={
                                            <Avatar
                                                sx={{
                                                    width: 24,
                                                    height: 24,
                                                    backgroundColor: 'gold',
                                                    fontSize: '0.75rem',
                                                    color: 'black',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                {data?.position}
                                            </Avatar>
                                        }
                                    >
                                        <Avatar sx={{ width: 56, height: 56 }}>IMG</Avatar>
                                    </Badge>
                                </Grid>

                                <Grid item xs={2}>
                                    <Typography variant="body1">Username: -</Typography>
                                    <Typography variant="body1">Full Name: -</Typography>
                                </Grid>

                                <Grid item xs={2} sx={{ textAlign: 'center' }}>
                                    <GradeIcon />
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: 'center' }}>
                                    <SmsIcon />
                                    <Typography variant="body2">{data?.totalComments} Comments</Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: 'center' }}>
                                    <VisibilityIcon />
                                    <Typography variant="body2">{data?.totalViews} Views</Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: 'center' }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            backgroundColor: '#4caf50',
                                            color: 'white',
                                            borderRadius: 1,
                                            padding: '4px 8px',
                                            display: 'inline-block',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {data?.prize} Chips
                                    </Typography>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: 'right' }}>
                                    <IconButton onClick={handleMenuOpen}>
                                        <MoreVertIcon />
                                    </IconButton>
                                    <Menu
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleMenuClose}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                    >
                                        <MenuItem onClick={handleMenuClose}>Assign Winner</MenuItem>
                                        <MenuItem onClick={handleMenuClose}>Remove Winner</MenuItem>
                                    </Menu>
                                </Grid>
                            </Grid>
                        </Paper>
                    </>
                })} */}
            </>

            {props?.eventDetails?.resultAnnounced ? <></> :
                < Box sx={{ textAlign: 'center', marginTop: 4 }}>
                    <Button variant="contained" color="primary" onClick={() => props?.handleResultAnnounce()}>
                        Announced Result
                    </Button>
                </Box>}


        </Box >
    );
}
